import styled, { css } from 'styled-components';

export const MainLayoutContainer = styled.div`
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100vh;
	height: calc(var(--vh, 1vh) * 100);
`;

export const MainLayoutContent = styled.div`
	${({ theme }) => css`
		width: 100%;
		height: 100vh;
		height: calc(var(--vh, 1vh) * 100);
		background-image: url(${theme.backgroundImage});
		background-size: cover;
		position: relative;
	`};
`;
